module.exports = __webpack_public_path__ + "img/lg_ring_r_l_null_null@2x.912e897e.png";